import React, { useState } from 'react';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaSpinner, FaCheckCircle, FaTimes, FaCertificate, FaExchangeAlt } from 'react-icons/fa';
import '../Assets/Styles/Pages/contact_page.css';

const Contact_page = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    message: ''
  });

  const [submitStatus, setSubmitStatus] = useState({
    loading: false,
    error: null,
    success: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus({ loading: true, error: null, success: false });

    try {
      const response = await fetch('https://tstock.trillionstechsolutions.com/enquiry-files/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.error || 'Failed to send message');
      }

      const result = await response.json();
      console.log('Message sent successfully:', result);
      setSubmitStatus({ loading: false, error: null, success: true });

      // Reset form after successful submission
      setFormData({
        fullName: '',
        emailAddress: '',
        phoneNumber: '',
        message: ''
      });

    } catch (error) {
      console.error('Error sending message:', error);
      setSubmitStatus({
        loading: false,
        error: error.message || 'Failed to send message. Please try again.',
        success: false
      });
    }
  };

  return (
    <div className="contact-page">
      <AboutNav />
      <SEBISlider />
      
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Get in Touch</h1>
          <p>We're here to help you with your investment journey</p>
        </div>
      </section>

      <section className="contact-container">
        <div className="contact-info">
          <div className="contact-card">
            <div className="contact-icon">
              <FaPhone />
            </div>
            <h3>Phone</h3>
            <p>+91 9977555378</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaEnvelope />
            </div>
            <h3>Email</h3>
            <p>mail.trillionstockresearch@gmail.com</p>
          </div>

          <div className="contact-info-item">
            <FaCertificate />
            <h3>SEBI Registration</h3>
            <p>INH000020129</p>
          </div>
          <div className="contact-info-item">
            <FaExchangeAlt />
            <h3>BSE Enlistment</h3>
            <p>6528</p>
          </div>
          <div className="contact-info-item">
            <FaMapMarkerAlt />
            <h3>Address</h3>
            <p>200 Sector A Suryadev Nagar, Indore, Madhya Pradesh, 452012</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaClock />
            </div>
            <h3>Working Hours</h3>
            <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
            <p>Saturday: 9:00 AM - 1:00 PM</p>
          </div>
        </div>

        <div className="contact-form-container">
          <h2>Send us a Message</h2>
          {submitStatus.error && (
            <div className="status-message error-message">
              <FaTimes className="status-icon" />
              {submitStatus.error}
            </div>
          )}

          {submitStatus.success && (
            <div className="status-message success-message">
              <FaCheckCircle className="status-icon" />
              Thank you for your message! We'll get back to you soon.
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="fullName">Your Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                disabled={submitStatus.loading || submitStatus.success}
              />
            </div>

            <div className="form-group">
              <label htmlFor="emailAddress">Email Address</label>
              <input
                type="email"
                id="emailAddress"
                name="emailAddress"
                value={formData.emailAddress}
                onChange={handleChange}
                required
                disabled={submitStatus.loading || submitStatus.success}
              />
            </div>

            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
                disabled={submitStatus.loading || submitStatus.success}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                disabled={submitStatus.loading || submitStatus.success}
              ></textarea>
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={submitStatus.loading || submitStatus.success}
            >
              {submitStatus.loading ? (
                <>
                  <FaSpinner className="spinner" />
                  Sending...
                </>
              ) : submitStatus.success ? (
                <>
                  <FaCheckCircle />
                  Message Sent
                </>
              ) : (
                'Send Message'
              )}
            </button>
          </form>
        </div>
      </section>

      <section className="map-section">
        <h2>Find Us</h2>
        <div className="map-container">
          <iframe
            title="Trillions office location on Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.123456789012345!2d75.12345678901234!3d22.12345678901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962c1234567890%3A0x1c1c1c1c1c1c1c1c!2s200%20Sector%20A%20Suryadev%20Nagar%2C%20Indore%2C%20Madhya%20Pradesh%2C%20452012!5e0!3m2!1sen!2sin!4v1234567890"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
      <ISOCertificateButton />
    </div>
  );
};

export default Contact_page;
